import React from 'react';
import {Pannel} from './pannel';
import Mpannel from './mpannel';
import Usar from './usar';
import { isMobile } from 'react-device-detect';
const Uder=()=>{
    document.title = "돌파공모"; 
return(
<>
{isMobile ? <Mpannel/> : <Pannel tito ="titi"/>}

<Usar/>
</>
);
}

export default Uder;